__turbopack_context__.v({
  "article-list-item": "styles-module-scss-module__TT3juW__article-list-item",
  "article-post-card": "styles-module-scss-module__TT3juW__article-post-card",
  "article-thumb": "styles-module-scss-module__TT3juW__article-thumb",
  "block-container": "styles-module-scss-module__TT3juW__block-container",
  "block-content": "styles-module-scss-module__TT3juW__block-content",
  "block-footer": "styles-module-scss-module__TT3juW__block-footer",
  "block-footer-action": "styles-module-scss-module__TT3juW__block-footer-action",
  "block-header": "styles-module-scss-module__TT3juW__block-header",
  "block-header-actions": "styles-module-scss-module__TT3juW__block-header-actions",
  "block-header-actions-desktop": "styles-module-scss-module__TT3juW__block-header-actions-desktop",
  "block-header-controls-only": "styles-module-scss-module__TT3juW__block-header-controls-only",
  "block-header-end": "styles-module-scss-module__TT3juW__block-header-end",
  "block-header-white": "styles-module-scss-module__TT3juW__block-header-white",
  "block-header-with-view-more": "styles-module-scss-module__TT3juW__block-header-with-view-more",
  "block-list-wrapper": "styles-module-scss-module__TT3juW__block-list-wrapper",
  "clean": "styles-module-scss-module__TT3juW__clean",
  "divider": "styles-module-scss-module__TT3juW__divider",
  "full-item": "styles-module-scss-module__TT3juW__full-item",
  "grid-item": "styles-module-scss-module__TT3juW__grid-item",
  "list-item": "styles-module-scss-module__TT3juW__list-item",
  "movers-column-header": "styles-module-scss-module__TT3juW__movers-column-header",
  "movers-column-header-gainers": "styles-module-scss-module__TT3juW__movers-column-header-gainers",
  "movers-column-header-losers": "styles-module-scss-module__TT3juW__movers-column-header-losers",
  "movers-column-icon": "styles-module-scss-module__TT3juW__movers-column-icon",
  "quote-card": "styles-module-scss-module__TT3juW__quote-card",
  "quote-card-header": "styles-module-scss-module__TT3juW__quote-card-header",
  "quote-card-logo": "styles-module-scss-module__TT3juW__quote-card-logo",
  "quote-card-name": "styles-module-scss-module__TT3juW__quote-card-name",
  "quote-card-price": "styles-module-scss-module__TT3juW__quote-card-price",
  "resource-group": "styles-module-scss-module__TT3juW__resource-group",
  "short-item": "styles-module-scss-module__TT3juW__short-item",
});
